import React from "react";
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';

const CountingH2 = ({ target, suffix }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  return (
    <h2 ref={ref}>
      {inView ? <CountUp end={target} duration={2} suffix={suffix} /> : `${target}${suffix}`}
    </h2>
  );
};

const cardVariants = {
  hidden: { x: -100, opacity: 0 },
  visible: { x: 0, opacity: 1, transition: { duration: 0.6 } }
};

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2
    }
  }
};

const Impact = () => {

   return(
    <>
       <section className="section impact-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-7">
                        <div className="heading-title">
                            <h1>Transforming Ideas into Measurable <span>Design Impact Over the Years</span></h1>
                            <p>A journey of designing user-focused products, delivering real results, and collaborating with teams to build meaningful digital experiences.</p>
                        </div>
                    </div>
                </div>
                <div className="impact-card">
                    <motion.div 
                        className="row"
                        variants={containerVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <motion.div className="col-md-3" variants={cardVariants}>
                            <div className="sl-card">
                                <CountingH2 target={13} suffix="+" />
                                <p>Scalable Design Systems Created</p>
                            </div>
                        </motion.div>
                        <motion.div className="col-md-3" variants={cardVariants}>
                            <div className="sl-card">
                                <CountingH2 target={6} suffix="" />
                                <p>Companies and teams partnered with</p>
                            </div>
                        </motion.div>
                        <motion.div className="col-md-3" variants={cardVariants}>
                            <div className="sl-card">
                                <CountingH2 target={80} suffix="+" />
                                <p>End-to-End Projects</p>
                            </div>
                        </motion.div>
                        <motion.div className="col-md-3" variants={cardVariants}>
                            <div className="sl-card">
                                <CountingH2 target={3} suffix="y" />
                                <p>Training / Teaching</p>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
                
            </div>

       </section>
       
    </>
   );
}

export default Impact;
